import {formatSizeUnits} from './BytesToMo'

const ARCHIVE_STRING = 'ZIP' || 'zip'
const PDF_CONTENTFUL_STRING = 'application/pdf'
const ARCHIVE_CONTENTFUL_STRING = 'application/zip'
const PDF_STRING = 'PDF' || 'pdf'

export const GetDocumentType = (file) => {
  const docExists =
    file &&
    ((file.name && file.cloudinary) || (file.contentfulAsset && file.name))

  if (docExists) {
    const size = formatSizeUnits(file.contentfulAsset?.file.details.size || file.cloudinary[0].bytes)
    const formatType = file.contentfulAsset?.file.contentType || file.cloudinary[0].format || file.cloudinary[0].url?.split('.').pop();
    const format = () => {
      switch (formatType) {
        case PDF_CONTENTFUL_STRING:
          return PDF_STRING
        case ARCHIVE_CONTENTFUL_STRING:
          return ARCHIVE_STRING
        default:
          return formatType.toUpperCase()
      }
    }
    return `${format()} - ${size}`
  }
  return null

}